import { Box, Button } from "@mui/material";
import React from "react";
import { config } from "../../../config";
import { AlertContext } from "../../../contexts";
import { NetworkCall } from "../../../networkcall";
import { AlertProps, NetWorkCallMethods } from "../../../utils";
import { ReservationCard } from "./reservationCard";
import { useNavigate } from 'react-router-dom';
import { Routes } from "../../../router/routes";

export const CancelBooking = ({ t, data = {}, reload = () => false, company_id = "", quotation_id = "", type, onClose = () => false }) => {
    const alert = React.useContext(AlertContext);
    const navigate = useNavigate();

    const onCancel = () => {
        const payload = {
            company_id: company_id,
            quotation_id: quotation_id
        }
        NetworkCall(
            `${config.api_url}/quotation/reserve/cancel`,
            NetWorkCallMethods.post,
            payload,
            null,
            true,
            false
        ).then(() => {
            navigate(Routes?.reservation)
            alert.setSnack({
                ...alert,
                open: true,
                severity: AlertProps.severity.success,
                msg: `${type} ${("Cancel Successfully")}`,
            });
            reload();
            onClose()
        }).catch((err) => {
            console.log(err)
            alert.setSnack({
                ...alert,
                open: true,
                severity: AlertProps.severity.error,
                msg: `${type} ${("Cannot be Cancel")}`,
            });
        })
    }

    return (
        <Box p={3}>
            <ReservationCard
                data={data}
                view={false}
                t={t}
            />
            <Box height="18px" />
            <Button onClick={onCancel} fullWidth variant="contained">{t("Cancel Booking")}</Button>
        </Box>
    )
}